import React, { useState } from "react";
import { Button } from 'react-bootstrap';
import i18n from "../../../../utils/ChrI18n";
import CookieUtils from "../../../../interfaces/CookieUtils.js";
import useCustomizeCookiePreferencesModal from "../CustomizeCookiePreferences/custom/useCustomizeCookiePreferencesModal.jsx";
import { setCookieAndHandleTracking } from "../utils.js";

const commonButtonClasses = "btn btn-md b-r-xs-important cui-cookie-consent-button-mobile-height";

const CookieConsentPopup = ({ data }) => {

  const [isVisible, setIsVisible] = useState(true);
  const { modalControls, modalContent } = useCustomizeCookiePreferencesModal(data, setIsVisible);

  const handleCustomizeButtonClick = () => {
    modalControls.showModal();
    CookieUtils.handleEventTracking(chrEventConstants.action.CLICKED_CUSTOMIZE_COOKIES);
  }

  const handleButtonClick = (cookieValue, eventActionName) => {
    setCookieAndHandleTracking(data, eventActionName, cookieValue);
    setIsVisible(false);
  }

  return (
    <>
      {
        isVisible &&
        <div className='d-flex flex-column align-items-start bg-accent-active gap-3 pt-5 pl-5 pb-6 pr-6 b-r-sm'>
          <div className="d-flex gap-3">
            <div className="heading-2xl">🍪</div>
            <div className='body-md text-primary-on-dark'>{i18n.t("feature.cookie_consent.content.cookies_to_remember_preferences")}</div>
          </div>
          <div className="d-flex flex-column flex-xs-row gap-2 w-100 pl-0 pl-xs-10">
            <Button bsClass={`${commonButtonClasses} border-interactive text-secondary-on-dark`} onClick={handleCustomizeButtonClick}>{i18n.t("feature.cookie_consent.button.Customize")}</Button>
            <Button bsClass={`${commonButtonClasses} border-interactive text-secondary-on-dark`} onClick={() => handleButtonClick(false, chrEventConstants.action.CLICKED_REJECT_ALL_COOKIES)}>{i18n.t("feature.cookie_consent.button.Reject_All")}</Button>
            <Button bsClass={`${commonButtonClasses} btn-white`} onClick={() => handleButtonClick(true, chrEventConstants.action.CLICKED_ACCEPT_ALL_COOKIES)}>{i18n.t("feature.cookie_consent.button.Accept_All")}</Button>
          </div>
        </div>
      }
      {modalContent}
    </>
  );
}

export default CookieConsentPopup;
